/**
 * @generated SignedSource<<e9ccf9893d2d81097bd8d289c7965ec6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CurrentEarningsCardRefetchQuery$variables = {
  id: string;
};
export type CurrentEarningsCardRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"CurrentEarningsCard_currentEarnings">;
  } | null;
};
export type CurrentEarningsCardRefetchQuery = {
  response: CurrentEarningsCardRefetchQuery$data;
  variables: CurrentEarningsCardRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CurrentEarningsCardRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CurrentEarningsCard_currentEarnings"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CurrentEarningsCardRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CurrencyAmount",
                "kind": "LinkedField",
                "name": "amount",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subUnitAmount",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "WalletBalance",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2d8fb94656584a5df97fb3c5aee7c308",
    "id": null,
    "metadata": {},
    "name": "CurrentEarningsCardRefetchQuery",
    "operationKind": "query",
    "text": "query CurrentEarningsCardRefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...CurrentEarningsCard_currentEarnings\n    id\n  }\n}\n\nfragment CurrentEarningsCard_currentEarnings on WalletBalance {\n  amount {\n    subUnitAmount\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "31f3cfc4fa14ffb5a2053d7fc6b1c8ff";

export default node;
